/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClaimRewardsResponseDataInner } from './ClaimRewardsResponseDataInner';
import {
    ClaimRewardsResponseDataInnerFromJSON,
    ClaimRewardsResponseDataInnerFromJSONTyped,
    ClaimRewardsResponseDataInnerToJSON,
} from './ClaimRewardsResponseDataInner';

/**
 * 
 * @export
 * @interface ClaimRewardsResponse
 */
export interface ClaimRewardsResponse {
    /**
     * 
     * @type {Array<ClaimRewardsResponseDataInner>}
     * @memberof ClaimRewardsResponse
     */
    data: Array<ClaimRewardsResponseDataInner>;
}

/**
 * Check if a given object implements the ClaimRewardsResponse interface.
 */
export function instanceOfClaimRewardsResponse(value: object): value is ClaimRewardsResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function ClaimRewardsResponseFromJSON(json: any): ClaimRewardsResponse {
    return ClaimRewardsResponseFromJSONTyped(json, false);
}

export function ClaimRewardsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimRewardsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ClaimRewardsResponseDataInnerFromJSON)),
    };
}

export function ClaimRewardsResponseToJSON(value?: ClaimRewardsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ClaimRewardsResponseDataInnerToJSON)),
    };
}

